<template>
	<div class="bHqwvv">
		<Header></Header>
		<div class="index_content">
			<div @click="goto('resources')" class="index_nav_1">
				<div class="index_nav_1_img"><img src="../../assets/image/1.png" alt=""></div>
				<div class="index_nav_name">数据资源目录</div>
			</div>
			<div class="index_nav_right">
				<div class="index_nav_right_top">
					<div @click="goto('service')" class="index_nav_2">
						<img src="../../assets/image/2.png" alt="">
						<div class="index_nav_name">用户管理</div>
					</div>
					<div @click="goto('industrialChain')" class="index_nav_2 index_nav_4">
						<img src="../../assets/image/5.png" alt="">
						<div class="index_nav_name">产业链管理</div>
					</div>
					<div @click="goto('report')" class="index_nav_2 index_nav_5">
						<img src="../../assets/image/4.png" alt="">
						<div class="index_nav_name">研报管理</div>
					</div>
				</div>
				<div class="nav-flex">
					<div @click="goto('epReport')" class="index_nav_3">
						<img src="../../assets/image/3.png" alt="">
						<div class="index_nav_name">企业管理</div>
					</div>
					<div @click="goto('setChart')" class="index_nav_3" style="background: rgba(0,128,128,0.6);">
						<img src="../../assets/image/6.png" alt="">
						<div class="index_nav_name">
							<span>图表配置</span>
							<br>
							<span>(小程序)</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import service from '@/http/request'
import Header from '@/components/index/header'
import store from '@/store'
export default {
  components:{
    Header
  },
	data(){
		return{
      		height:document.documentElement.clientHeight,
			isShowList:[]
		}
	},
	mounted:function(){
		//this.getMenuItemList()
	},
	methods:{
		goto:function(code){
			var t_=this
			//判断是否有权限
			//只有父级
			let parentRouter=store.state.permission.routes.find(t=>t.parentId==0  && t.path.split('/').length>2 && t.path.split('/')[1] == code)
			if(parentRouter){
				t_.$router.push(parentRouter.path)
				return
			}
			//子级
			let childRouter=store.state.permission.routes.find(t=>t.parentId!=0 && t.path.split('/').length>2 && t.path.split('/')[1] == code)
			if(childRouter){
				t_.$router.push(childRouter.path)
				return
			}
			t_.$alert('没有权限', '提示', {
				confirmButtonText: '确定',
				type: 'warning'
			});
			
			//if(t_.isShowList.find(t=>t.code==code)){
			//	var href=t_.$router.resolve({name: code,query: {}})
			//	window.open(href.href,'_self')
			// }else{
			// 	t_.$alert('没有权限', '提示', {
			// 		confirmButtonText: '确定',
			// 		type: 'warning'
			// 	});
			// }
		},
		/**
		 * 获取菜单列表
		 */
		async getMenuItemList(){
			var t_=this
			let params={
				userId:parseInt(localStorage.userId || 0),
				appID:parseFloat(localStorage.appId || 0)
			} 
			console.log(params)
			let res=await service.post(`api/Business/GetUserMenuList`,params)
        	console.log('用户菜单列表', res)
			if(res.data.code==20000){
				t_.isShowList=res.data.data.filter(t=>t.parentId==0)
        	}
		},
	}
}
</script>

<style scoped>
	.bHqwvv {
		height: 100%;
		display: flex;
		flex-direction: column;
		background-color: rgba(215,233,255,0.3);
	}
	.index_header_box{
		width: 100%;
		height: 62px;
		background: #344863;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 2033;
	}
	.index_header_logo{
		width: 42px;
		height: 50px;
		margin: 5px 25px 0 40px;
	}
	.index_header_logo img{
		width: 42px;
		height: 50px;
	}
	.index_header_title{
		line-height: 62px;
		color: #fff;
		font-size: 18px;
		font-weight: 900;
    	font-style:oblique;
	}
	.index_header_function{
		width: 30px;
		height: 30px;
		margin-right: 50px;
    	margin-top: 17px;
		cursor: pointer;
	}
	.index_header_function img{
		width: 30px;
		height: 30px;
	}
	.index_content{
		background: linear-gradient(to bottom, rgba(240, 240, 240, 1), rgba(198, 210, 246, 0.5));
		flex: 1;
		padding: 20px;
	}

	@media (min-width: 768px) {
		.index_content {
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
	.index_nav{
		width: 1200px;
		height: 400px;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}
	.index_nav_1{
		width: 100%;
		height: auto;
		background: rgba(255,170,0,.6);
		margin-bottom: 10px;
		cursor: pointer;
		border-radius: 4px;
	}

	@media (min-width: 768px) {
		.index_nav_1 {
			width: 250px;
			height: 400px;
			margin-right: 10px;
			margin-bottom: 0;
		}
	}
	.index_nav_1_img{
		width: 100px;
		height: 100px;
		margin: 0 auto;
		margin-top: 125px;
		margin-bottom: 20px;
	}
	.index_nav_1 img,.index_nav_2 img,.index_nav_3 img{
		width: 60px;
		height: 60px;
	}
	.index_nav_name{
		font-size: 16px;
		color: #fff;
		text-align: center;
		margin-top: 8px;
		line-height: 1.4;
	}
	
	.index_nav_1:active,
	.index_nav_2:active,
	.index_nav_3:active {
		opacity: 0.8;
		transform: scale(0.98);
	}

	@media (min-width: 768px) {
		.index_nav_1 img,.index_nav_2 img,.index_nav_3 img{
			width: 100px;
			height: 100px;
		}
		.index_nav_name{
			font-size: 20px;
			margin-top: 12px;
		}
	}
	.index_nav_right{
		width: 100%;
		height: auto;
	}
	.index_nav_right_top{
		margin-bottom: 10px;
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	@media (min-width: 768px) {
		.index_nav_right {
			width: 940px;
			height: 400px;
		}
		.index_nav_right_top {
			flex-direction: row;
			height: 200px;
		}
	}
	.index_nav_2{
		width: 306px;
		/* background: linear-gradient(to bottom, rgba(28,56,106,.5) , rgba(104,192,40,.5)); */
		background: rgba(104,192,40,.6);
		cursor: pointer;
		border-radius: 4px;
		display: flex;
    	justify-content: center;
    	align-items: center;
    	flex-direction: column;
	}
	.nav-flex{
		display: flex;
		height: 190px;
		gap: 10px;
	}
	.index_nav_3{
		flex: 1 1 auto;
		background: rgba(0,119,214,.6);
		cursor: pointer;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.index_nav_4{
		/* background: linear-gradient(to bottom,  rgba(233,52,206,.5), rgba(28,56,106,.5)); */
		background: rgba(233,52,206,.6);
		cursor: pointer;
	}
	.index_nav_5{
		/* background: linear-gradient(to bottom, rgba(28,56,106,.5), rgba(255,58,14,.5)); */
		background: rgba(255,58,14,.6);
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue